import { combineReducers } from "redux";
import { player } from "./player";
import { category } from "./category";

export default combineReducers({
    player,
    category
});
